import { observer } from 'mobx-react'
import { FC } from 'react'

import { EMPTY_FILTER_ID } from '@new/domains/operations/screens/CasesV2/CasesV2.constants'
import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'

import { TruncatedListPreview } from './TruncatedListPreview'

interface CaseVendorsPreviewFormatterProps {
  values?: string[]
}

const _CaseVendorsPreviewFormatter: FC<CaseVendorsPreviewFormatterProps> = ({ values }) => {
  const { vendorsByRecordTypes, isLoadingCaseVendors } = casesFilterOptionsStore
  if (isLoadingCaseVendors) return '...'

  const names =
    values
      ?.map(value =>
        value === EMPTY_FILTER_ID
          ? 'N/A'
          : vendorsByRecordTypes?.find(option => option?.id === value)?.name,
      )
      .filter((name): name is string => Boolean(name)) ?? []

  return <TruncatedListPreview names={names} />
}

export const CaseVendorsPreviewFormatter = observer(_CaseVendorsPreviewFormatter)
